import React from 'react';
import ErrorBoundary from './ErrorBoundary';

const SafeComponent = ({ children, fallback, name = "Component" }) => {
  const DefaultFallback = ({ error, retry }) => (
    <div className="p-4 border border-dashed border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-900 dark:border-gray-700">
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
        Failed to load {name}
      </p>
      <button 
        onClick={retry}
        className="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
      >
        Try again
      </button>
    </div>
  );

  return (
    <ErrorBoundary fallback={fallback || DefaultFallback}>
      {children}
    </ErrorBoundary>
  );
};

export default SafeComponent;